"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// core
var imageCropperModule_1 = require("./src/imageCropperModule");
exports.ImageCropperModule = imageCropperModule_1.ImageCropperModule;
var imageCropperComponent_1 = require("./src/imageCropperComponent");
exports.ImageCropperComponent = imageCropperComponent_1.ImageCropperComponent;
// extra classes
var imageCropper_1 = require("./src/imageCropper");
exports.ImageCropper = imageCropper_1.ImageCropper;
var cropperSettings_1 = require("./src/cropperSettings");
exports.CropperSettings = cropperSettings_1.CropperSettings;
var cropperDrawSettings_1 = require("./src/cropperDrawSettings");
exports.CropperDrawSettings = cropperDrawSettings_1.CropperDrawSettings;
// models
var bounds_1 = require("./src/model/bounds");
exports.Bounds = bounds_1.Bounds;
var cropPosition_1 = require("./src/model/cropPosition");
exports.CropPosition = cropPosition_1.CropPosition;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-img-cropper/index.js
// module id = 372
// module chunks = 26